import commonRequest from "./common";

export default {
  methods: {
    standardRequest(options, uri, callback, onError) {
      const baseUrl = process.env.VUE_APP_API;
      const onSuccess = callback;
      commonRequest(baseUrl, options, uri, onSuccess, onError);
    },
  },
};
